import React, { useState, useLayoutEffect, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth, startOfDay, endOfDay, addDays } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { DataGrid } from '@mui/x-data-grid';
import { Spin } from "antd"
import StorageService from "../../utils/storage.service";
import "./scss/report.scss"
import 'antd/dist/antd.min.css'
import { Tooltip } from "antd";

const DetailPromotion = () => {
    const [title, setTitle] = useState("Chi tiết promotion")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [groupId, setGroupId] = useState(0)
    const [voucherName, setVoucherName] = useState(null)
    const [dataChart, setDataChart] = useState([])
    const [rows, setRows] = useState([])
    const [totalVouchers, setTotalVouchers] = useState(0)
    const [totalOrderPrice, setTotalOrderPrice] = useState(0)
    const [totalRevenue, setTotalRevenue] = useState(0)

    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const history = useHistory();
    const [pageSize, setPageSize] = useState(10)


    let currentUrl = window.location.pathname
    if (currentUrl.includes('report/detail-promotion') && [3, 4].includes(userAdmin.role)) history.push('/report/daily');

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const columns = [
        { field: 'voucher_code', headerName: 'Tên voucher', width: 400, cellClassName: (params) => "text" },
        { field: 'group_voucher_name', headerName: 'Tên chương trình', width: 330, cellClassName: (params) => "text" },
        { field: 'orders', headerName: 'Số đơn hàng', type: "number", width: 150, styles: { color: "red" } },
        {
            field: 'receipt',
            headerName: 'Tổng tiền giảm',
            description: 'Tổng số tiền giảm khi áp dụng chương trình ưu đãi tương ứng.',
            type: "number",
            width: 200,
            valueGetter: (params) => convertCurrency(params.row.receipt),
            cellClassName: (params) => "text1"
        },
        {
            field: 'deposit',
            headerName: 'Doanh số thuần',
            description: 'Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh số - Giảm giá)',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.deposit), width: 200,
            cellClassName: (params) => "text4"
        },
        {
            field: 'revenue_price',
            headerName: 'Thực thu',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.revenue_price ?? 0), width: 150,
            cellClassName: (params) => "text4"
        },
        {
            field: 'gift_cash',
            headerName: 'Giá gốc',
            description: 'Doanh số khi chưa trừ khuyến mãi',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.gift_cash ?? 0), width: 150,
            cellClassName: (params) => "text4"
        },
        {
            field: 'new_customer',
            headerName: 'Khách mới',
            type: "number",
            valueGetter: (params) => params.row.new_customer ?? 0, width: 100,
            cellClassName: (params) => "text4"
        },
        {
            field: 'old_customer',
            headerName: 'Khách cũ',
            type: "number",
            valueGetter: (params) => params.row.old_customer ?? 0, width: 100,
            cellClassName: (params) => "text4"
        },
        {
            field: 'percent',
            headerName: 'Tỷ lệ giảm giá',
            description: 'Số tiền giảm/Doanh số chưa khuyến mãi',
            width: 150,
            type: "number",
            cellClassName: (params) => "text4"
        },
    ];
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(endDate, startDate, groupId, voucherName)
    }, [endDate, startDate, groupId, voucherName])
    const fetchData = async (eD, sD, groupId, voucherName) => {
        let doneData = false
        let DoneLocation = false
        const { data, locations } = await async.parallel({
            data: (cb) => {
                axiosService(`api/reports/detail-vouchers?&startDate=${sD}&endDate=${eD}&groupId=${groupId}&voucherName=${voucherName}`, "GET").then(rs => {
                    const { data } = rs
                    if (data.code == 200) {
                        doneData = true
                        cb(null, data.data.data)
                    }
                })
            },
            locations: (cb) => {
                axiosService("api/stores", "GET").then(rs => {
                    const { data } = rs
                    if (data.code == 200) {
                        DoneLocation = true
                        cb(null, data.data)
                    }
                })
            }
        })
        if (doneData && DoneLocation) {
            setLoading(false)
            Promise.all(data.map(x => {
                return { name: x.group_voucher_name, value: parseInt(x.sum_voucher_order_price) || 0 }
            })).then(rs => {
                setDataChart(rs)
            })
            Promise.all(data.map((x, i) => {
                return {
                    id: i+1, 
                    voucher_code: x.voucher_code,
                    group_voucher_name: x.group_voucher_name,
                    orders: x.count_order_using,
                    receipt: x.sum_voucher_order_price,
                    deposit: x.sum_total_price,
                    gift_cash: x.sum_total_price_before,
                    percent: Number(x.sum_voucher_order_price/ x.sum_total_price_before * 100).toFixed(1) + ' %',
                    revenue_price: x.count_revenue_price,
                    new_customer: x.count_new_customer,
                    old_customer: x.count_old_customer
                }
            })).then(rs => {
                let sum_voucher_order_price = _.sumBy(rs, function(o) { return  Number(o.receipt); });
                let sum_total_price = _.sumBy(rs, function(o) { return Number(o.deposit); });
                let sum_total_price_before = _.sumBy(rs, function(o) { return Number(o.gift_cash); });
                let sum_total_revenue = _.sumBy(rs, function(o) { return Number(o.revenue_price); });
                setTotalOrderPrice(sum_total_price)
                setTotalVouchers(sum_voucher_order_price)
                setTotalRevenue(sum_total_revenue)
                setRows(rs)
            })

        }

    }

    const handleExportData = async () => {
        setLoading(true);
        try {
            const header = {
                voucher_code: "Tên voucher",
                group_voucher_name: "Tên chương trình",
                orders: "Số đơn hàng",
                receipt: "Tổng tiền giảm",
                deposit: "Doanh số thuần",
                revenue_price: "Thực thu",
                gift_cash: "Tổng doanh số chưa khuyến mãi",
                new_customer: "Khách mới",
                old_customer: "Khách cũ",
                percent: "Tỷ lệ giảm giá",
            };
            const listExport = [
                _.values(header),
                ..._.map(rows, (item) => _.values(_.pick(item, _.keys(header)))),
            ];
            const payload = {
                name: "chi_tiet_promotion",
                sheets: [{ 
                    name: "Chi tiết promotion", 
                    data: listExport 
                }],
            };

            const res = await axiosService("api/mysql/export/have-data", "POST", payload);

            if (res.data.code === 200 && res.data.data?.url) {
                window.open(res.data.data.url, "_blank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    const handleGroupVoucher = (e) => {
        setGroupId(e)
    }
    const handleSearchVoucher = (e) => {
        setVoucherName(e)
    }
    const handleExportHd = (e) => {
        setLoading(true)
         var url = "api/mysql/export/export-detail-voucher" + "?startDate=" + startDate + "&" + "endDate=" + endDate + "&" + "groupId=" + groupId + "&" + "voucherName=" + voucherName
         axiosService(url, "GET").then((res) => {
            if (res.data.code == 200) {
                window.open(res.data.data.url, '_blank');
                setLoading(false)
            }
        }).catch((error) => {
            setLoading(false)
        });
    }

    const  handleChange = (e) => {
        setPageSize(e)
    }
    return (
        <>
            <div className={`${styles.background} container-fluid report-page`}>
                <FilterReport startDate={startDate} endDate={endDate}
                    handleRangeDate={handleRangeDate}
                    handleStore={handleGroupVoucher}
                    handleSearchVoucher={handleSearchVoucher}
                    title={title} type={"detail_promotion"}
                    csvData={rows} isExport={isExport}
                    handleExportData={handleExportData}
                    handleExportHd={handleExportHd}
                    header={
                        [
                            { label: 'Tên chương trình', key: "name" },
                            { label: "Số đơn hàng", key: "orders" },
                            { label: "Tổng tiền chương trình", key: "receipt" },
                            { label: "Tổng tiền phải thu đơn hàng", key: "deposit" },
                            { label: "Tổng doanh số", key: "gift_cash" },
                        ]
                    }
                    userAdmin={userAdmin}
                />
                <Spin spinning={loading}>
                    <Row className="pt-2">
                        <Col xs={12}>
                            <Row>
                                <Col xs={12} md={6} lg={3} className="mb-2">
                                    <Tag color="blue" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>
                                        <Tooltip className="show-tooltip" title='Tổng số tiền trước giảm giá của những đơn hàng có áp dụng mã'> TỔNG DOANH SỐ CHƯA KHUYẾN MÃI:  <i className="fas fa-info-circle"></i></Tooltip>
                                        </span>
                                        <div className="d-flex justify-content-start">
                                            <span className={styles.textTag}>{convertCurrency(Number(totalOrderPrice) + Number(totalVouchers))}</span>
                                            {/* <span className={styles.textTag}>{convertCurrency(receipt?.totalByOrder?.sum_total_price - receipt?.totalByOrder?.sum_deposit_total - receipt?.totalByOrder?.sum_gift_cash_total)}</span> */}

                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={6} lg={3} className="mb-2">
                                    <Tag color="cyan" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>
                                        <Tooltip className="show-tooltip" title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh số - Giảm giá)'> TỔNG DOANH SỐ THUẦN:  <i className="fas fa-info-circle"></i></Tooltip>

                                        </span>
                                        <div className="d-flex justify-content-start">
                                            <span className={styles.textTag}>{convertCurrency(Number(totalOrderPrice))}</span>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={6} lg={3} className="mb-2">
                                    <Tag color="violet" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>
                                        <Tooltip className="show-tooltip" title='Tổng số tiền khách hàng được chiết khấu, giảm giá sau khi áp dụng mã ưu đãi.'> TỔNG GIẢM VOUCHER:  <i className="fas fa-info-circle"></i></Tooltip>

                                        </span>
                                        <div className="d-flex justify-content-start">
                                            <span className={styles.textTag}>{convertCurrency(Number(totalVouchers))}</span>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={6} lg={3} className="mb-2">
                                    <Tag color="green" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>
                                        <Tooltip className="show-tooltip" title='Tổng số tiền đã thu về từ mọi nguồn'> TỔNG THỰC THU:  <i className="fas fa-info-circle"></i></Tooltip>

                                        </span>
                                        <div className="d-flex justify-content-start">
                                            <span className={styles.textTag}>{convertCurrency(Number(totalRevenue))}</span>
                                        </div>
                                    </Tag>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <div style={{ backgroundColor: "white" }} className="p-2">
                                <div className="mb-2">
                                    <strong>Bảng dữ liệu chi tiết</strong>
                                </div>
                                <DataGrid
                                    autoHeight
                                    rows={rows}
                                    columns={columns}
                                    pageSize={pageSize}
                                    onPageSizeChange={handleChange}
                                    rowsPerPageOptions={[10,15,30, 100]}
                                />
                            </div>
                        </Col>
                    </Row>
                </Spin>
            </div>
        </>
    )
}
export default DetailPromotion